import React from "react";
import { Routes, Route } from "react-router-dom";
import FormsList from "../pages/FormBuilder/FormsList";
import UserDashboard from "../pages/Dashboard/UserDashboard";
import EmployeeDetails from "../pages/payroll/EmployeeDetails";
import HiringRequests from "../pages/HiringRequests/HiringRequests";
import RecruitmentResponses from "../pages/HiringRequests/RecruitmentResponses";
import HODRequests from "../pages/HODRequests/HODRequests";
import Campaigns from "../pages/Campaigns/Campaigns";
import Candidates from "../pages/Candidates/Candidates";
import Interviews from "../pages/Interviews/Interviews";
import MyRequests from "../pages/HiringRequests/MyRequests";
import Resignation from "../pages/Resignation/resignation";
import RecruitmentDashboard from "../pages/Dashboard/RecruitmentDashboard";
import ScheduledInterviews from "../pages/Interviews/ScheduledInterviews";
import FormBuilder from "../components/Forms/FormBuilder";
import FormRender from "../pages/FormBuilder/FormRender";
import AssignRoles from "../pages/Assignment/AssignRoles";
import AssignPermissions from "../pages/Assignment/AssignPermissions";
import ManageRoles from "../pages/Roles/ManageRoles";
import EditRole from "../pages/Roles/EditRole";
import ManagePermissions from "../pages/Permissions/ManagePermissions";
import EditPermission from "../pages/Permissions/EditPermission";
import Users from "../pages/Users/Users";
import DepartmentMasters from "../pages/Masters/DepartmentMasters";
import EmploymentTypeMasters from "../pages/Masters/EmploymentTypeMasters";
import WorkplaceMasters from "../pages/Masters/WorkplaceMasters";
import LeaveTypeMasters from "../pages/Masters/LeaveTypeMasters";
import ShiftMasters from "../pages/Masters/ShiftMasters";
import HolidayMasters from "../pages/Masters/HolidayMasters";
import LeaveBalanceMasters from "../pages/Masters/LeaveBalanceMasters";
import ManageFiles from "../pages/Files/ManageFiles";
import DesignationMasters from "../pages/Masters/DesignationMasters";
import Time from "../pages/Time/Time";
import MultiOptions from "../pages/AttendanceManagement/MultiOptions";

import { ResignationProvider } from "../contexts/ResignationContext";
import { HiringRequestsProvider } from "../contexts/HiringRequestsContext";
import { MyHiringRequestsProvider } from "../contexts/MyHiringRequestsContext";
import { CampaignsProvider } from "../contexts/CampaignsContext";
import { CandidateProvider } from "../contexts/CandidateContext";
import { InterviewsProvider } from "../contexts/InterviewsContext";
import { ScheduleInterviewsProvider } from "../contexts/ScheduleInterviewContext";
import { MyInterviewsProvider } from "../contexts/MyInterviewsContext";
import { UsersProvider } from "../contexts/UsersContext";
import { ProtectedRoute, PublicRoute } from "./ProtectedRoute";
import { MastersProvider } from "../contexts/MastersContext";
import { DepartmentMasterProvider } from "../contexts/DepartmentMasterContext";
import { FormsMasterProvider } from "../contexts/FormsMasterContext";
import ViewRequests from "../pages/HiringRequests/ViewRequests";
import { FormsProvider } from "../contexts/FormsContext";
import MyScheduledInterviews from "../pages/Interviews/MyScheduledInterviews";
import { RecruitmentDashboardProvider } from "../contexts/RecruitmentDashboardContext";
import UploadResumes from "../pages/Files/UploadResumes";
import OfferLettersPage from "../pages/OfferLetters/OfferLettersPage";
import { OfferLettersProvider } from "../contexts/OfferLettersContext";
import DocumentGenerator from "../pages/Files/DocumentGenerator";
import OfferTemplatesPage from "../pages/OfferLetters/OfferTemplatesPage";
import { OfferTemplatesProvider } from "../contexts/OfferTemplatesContext";
import { RoleProvider } from "../contexts/RoleContext";
import { PermissionProvider } from "../contexts/PermissionContext";
import { EmploymentTypeMasterProvider } from "../contexts/EmploymentTypeMasterContext";
import { LeaveTypeMasterProvider } from "../contexts/LeaveTypeMasterContext";
import { WorkplaceMasterProvider } from "../contexts/WorkplaceMasterContext";
import { DesignationMasterProvider } from "../contexts/DesignationsContext";
import AttendancePage from "../pages/Time/Attendance";
import SwipeRequest from "../pages/Time/SwipeRequest";
import ShortTimeOff from "../pages/Time/ShortTimeOff";
import ShiftChange from "../pages/Time/ShiftChange";
import Leave from "../pages/Leave/Leave";
import LeavePage from "../pages/Leave/LeavePages";
import COPlusPage from "../pages/Leave/COPlusPage";
import OutdoorDutyPage from "../pages/Leave/OutdoorDutyPage";
import MobileAttendance from "../pages/Time/MobileAttendance";
import CameraPage from "../pages/Time/CameraPage";
import LeaveApproverPage from "../pages/Masters/LeaveRequests";
import { ShiftTimingMasterProvider } from "../contexts/ShiftTimingMasterContext";
import { HolidayMasterProvider } from "../contexts/HolidayContext";
import AttendanceApiPage from "../pages/Time/AttendanceApiPage";
import HolidaysList from "../pages/Time/HolidaysList";
import LeaveBalance from "../pages/Leave/LeaveBalance";
import FormResponsePage from "../pages/FormResponse/FormResponse";
import PublicHolidayCalendar from "../pages/Leave/PublicHolidayCalendar";
import Dashboard from "../pages/payroll/Dashboard";
import EmploymentDetailsManagement from "../pages/payroll/EmploymentDetailsManagement";
import AttendanceLeave from "../pages/payroll/AttendanceLeave";
import PayrollProcessing from "../pages/payroll/PayrollProcessing";
import PayslipGeneration from "../pages/payroll/PayslipGeneration";
import SalaryDisbursement from "../pages/payroll/SalaryDisbursement";
import StatutoryCompliance from "../pages/payroll/StatutoryCompliance";
import PayrollReports from "../pages/payroll/PayrollReports";
import PayrollSettings from "../pages/payroll/PayrollSettings";

import PayrollComponents from "../pages/payroll/PayrollComponents";

// New Payroll Processing Pages
import GeneratePayroll from "../pages/payroll/GeneratePayroll";
import ProcessedRecords from "../pages/payroll/ProcessedRecords";
import ApprovalWorkflow from "../pages/payroll/ApprovalWorkflow";
import PayslipGenerationNew from "../pages/payroll/PayslipGenerationNew";
import PayrollSummary from "../pages/payroll/PayrollSummary";
import MyPayrolls from "../pages/payroll/MyPayrolls";

import OnBoardingFormResponsePage from "../pages/FormResponse/OnBoardingFormResponse";
import CheckInApprovalPage from "../pages/ApprovalAttendance/CheckInApprovalPage";
import CheckOutApprovalPage from "../pages/ApprovalAttendance/CheckOutApprovalPage";
import { EmploymentDetailsProvider } from "../contexts/EmploymentManagementContext";
import { EmployeeDetailsProvider } from "../contexts/EmployeeDetailsContext";
import CheckAttendancePage from "../pages/Time/CheckAttendance";
import { EmergencyContactsProvider } from "../contexts/EmergencyContacts";
import { LeaveBalanceProvider } from "../contexts/LeaveBalanceContext";
import EmergencyContacts from "../pages/EmergencyContacts/EmergencyContacts";
import CheckLeaveBalance from "../pages/Leave/CheckLeaveBalance";
import MyApprovers from "../pages/Leave/MyApprovers";
import SalaryStructure from "../pages/payroll/SalaryStructure";
import AttendanceDashboard from "../pages/Dashboard/AttendanceDashboard";
import MainLayout from "../layouts/MainLayout";
import FormsMaster from "../pages/Masters/FormsMaster";
import DepartmentHODMasters from "../pages/Masters/DepartmentHODMasters";
import CardDesigner from "../components/BirthdayCards/CardDesigner";
import ApplicationResponses from "../pages/FormResponse/ApplicationResponses";
import StateCodeMasters from "../pages/Masters/StateCodeMasters";
import SalaryGradeMasters from "../pages/Masters/SalaryGradeMasters";
import { StateCodeMasterProvider } from "../contexts/StateCodesContext";
import EmployeeGradeMasters from "../pages/Masters/EmployeeGradeMasters";
import { EmployeeGradeMasterProvider } from "../contexts/EmployeeGradesContext";
import { CategoryMasterProvider } from "../contexts/CategoryMasterContext";
import CategoryMasters from "../pages/Masters/CategoryMasters";
// import { CategoryMasterProvider } from "../contexts/CategoryMasterContext";
import { SalaryGradeMasterProvider } from "../contexts/SalaryBandContext";
import { ApproverModuleMasterProvider } from "../contexts/ApproverModuleContext";
import ApproverModuleMaster from "../pages/Masters/ApproverModules";
import { EmployeeApproverMasterProvider } from "../contexts/EmployeeApproverContext";
import EmployeeApproverMaster from "../pages/Masters/EmployeeApproverMaster";
import { ApprovalLevelMasterProvider } from "../contexts/ApprovalLevelContext";
import ApprovalLevelMaster from "../pages/Masters/ApprovalLevel";
import { LeavePolicyMasterProvider } from "../contexts/LeavePolicyContext";
import { ConfigurationComponentTypeMasterProvider } from "../contexts/ConfigurationComponentType";
import LeavePolicyMaster from "../pages/Masters/LeavePolicyMaster";
import SalaryComponentMaster from "../pages/Masters/SalaryComponentMaster";
import PayStructureMaster from "../pages/Masters/PayStructureMaster";
import EligibilityRuleMaster from "../pages/Masters/EligibilityRuleMaster";
import EmployeeSalaryAssignment from "../pages/Masters/EmployeeSalaryAssignment";
import MonthlyReports from "../pages/payroll/MonthlyReports";
import DepartmentReports from "../pages/payroll/DepartmentReports";
import MyPayslips from "../pages/payroll/MyPaySlips";
import EmployeeDashboard from "../pages/payroll/EmployeeDashboard";
import MySalaryStructure from "../pages/payroll/MySalaryStructure";
import TaxDocuments from "../pages/payroll/TaxDocuments";
import Certificates from "../pages/payroll/MyCertificates";
import Reimbursements from "../pages/payroll/Reimbursements";
import TaxConfigPage from "../pages/payroll/TaxConfigPage";
import CompanyPolicies from "../pages/Policy/CompanyPolicies";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Default Dashboard Route */}
      <Route
        path="/"
        element={
          <ProtectedRoute
            allowedRoles={["Admin", "Manager", "User", "HR", "HOD"]}
          >
            <MainLayout>
              <UserDashboard />
            </MainLayout>
          </ProtectedRoute>
        }
      />
      {/* Policy Route */}
      <Route
        path="/policy"
        element={
          <ProtectedRoute
            allowedRoles={["Admin", "HR", "Manager", "User", "Employee"]}
          >
            <MainLayout>
              <CompanyPolicies />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Payroll section */}

      {/* dashboard */}
      <Route
        path="/payroll/dashboard"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <Dashboard />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* employee details*/}
      <Route
        path="/payroll/employees/employee-details"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <EmployeeDetailsProvider>
                <EmployeeDetails />
              </EmployeeDetailsProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* employment details management */}
      <Route
        path="/payroll/employees/employment-details-management"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <EmploymentDetailsProvider>
                <EmploymentTypeMasterProvider>
                  <MastersProvider>
                    <DesignationMasterProvider>
                      <EmployeeGradeMasterProvider>
                        <SalaryGradeMasterProvider>
                          <CategoryMasterProvider>
                            <StateCodeMasterProvider>
                              <ShiftTimingMasterProvider>
                                <EmploymentDetailsManagement />
                              </ShiftTimingMasterProvider>
                            </StateCodeMasterProvider>
                          </CategoryMasterProvider>
                        </SalaryGradeMasterProvider>
                      </EmployeeGradeMasterProvider>
                    </DesignationMasterProvider>
                  </MastersProvider>
                </EmploymentTypeMasterProvider>
              </EmploymentDetailsProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* attendance leave */}
      <Route
        path="/payroll/attendance-leave"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <HolidayMasterProvider>
                <AttendanceLeave />
              </HolidayMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payslip generation*/}
      <Route
        path="/payroll/payslip-generation"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayslipGeneration />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* salary disbursement*/}
      <Route
        path="/payroll/salary-disbursement"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <SalaryDisbursement />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* statutory compliance*/}
      <Route
        path="/payroll/statutory-compliance"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <StatutoryCompliance />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll configuration */}
      <Route
        path="/payroll/configuration"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayrollReports />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll configuration compo */}
      <Route
        path="/payroll/configuration/components"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <ConfigurationComponentTypeMasterProvider>
                <PayrollComponents />
              </ConfigurationComponentTypeMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* salary Structure*/}
      <Route
        path="/payroll/configuration/salary-structures"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <UsersProvider>
                <SalaryStructure />
              </UsersProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll config settings */}
      <Route
        path="/payroll/configuration/settings"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayrollSettings />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll config tax */}
      <Route
        path="/payroll/configuration/tax"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <TaxConfigPage />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll config tax */}
      <Route
        path="/payroll/configuration/tax"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayrollSettings />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll employee */}
      <Route
        path="/payroll/employees"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayrollReports />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* employee salary Structure*/}
      <Route
        path="/payroll/employees/salary-structures"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <UsersProvider>
                <SalaryStructure />
              </UsersProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* employee bulk update */}
      <Route
        path="/payroll/employees/bulk-updates"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <UsersProvider>
                <SalaryStructure />
              </UsersProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* employee import/exports */}
      <Route
        path="/payroll/employees/import-export"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <UsersProvider>
                <SalaryStructure />
              </UsersProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll processing */}
      <Route
        path="/payroll/processing"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayrollProcessing />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll processing generate */}
      <Route
        path="/payroll/processing/generate"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <EmploymentDetailsProvider>
                <GeneratePayroll />
              </EmploymentDetailsProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll processing records */}
      <Route
        path="/payroll/processing/records"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <ProcessedRecords />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll processing approvals */}
      <Route
        path="/payroll/processing/approvals"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <ApprovalWorkflow />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll processing payslips */}
      <Route
        path="/payroll/processing/payslips"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayslipGeneration />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll summary */}
      <Route
        path="/payroll/summary"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayrollSummary />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* my payrolls - for employees */}
      <Route
        path="/payroll/my-payrolls"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "User"]}>
            <MainLayout>
              <MyPayrolls />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* reports */}
      <Route
        path="/payroll/reports"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayrollReports />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll reports monthly */}
      <Route
        path="/payroll/reports/monthly"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <MonthlyReports />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll reports department */}
      <Route
        path="/payroll/reports/department"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <DepartmentReports />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll reports statutory */}
      <Route
        path="/payroll/reports/statutory"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayrollReports />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll reports custom */}
      <Route
        path="/payroll/reports/custom"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayrollReports />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll audit */}
      <Route
        path="/payroll/audit"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayrollReports />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll audit logs */}
      <Route
        path="/payroll/audit/logs"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayrollReports />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll audit history */}
      <Route
        path="/payroll/audit/history"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayrollReports />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll audit changes */}
      <Route
        path="/payroll/audit/changes"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayrollReports />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll admin */}
      <Route
        path="/payroll/admin"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayrollReports />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll admin users */}
      <Route
        path="/payroll/admin/users"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayrollReports />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll admin roles */}
      <Route
        path="/payroll/admin/roles"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayrollReports />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll admin notifications */}
      <Route
        path="/payroll/admin/notifications"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayrollReports />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* payroll admin backup */}
      <Route
        path="/payroll/admin/backup"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayrollReports />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* my-payroll */}
      <Route
        path="/my-payroll"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "User"]}>
            <MainLayout>
              <PayrollReports />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* my-payroll dashboard */}
      <Route
        path="/my-payroll/dashboard"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "User"]}>
            <MainLayout>
              <EmployeeDashboard />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* my-payroll payslips */}
      <Route
        path="/my-payroll/payslips"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "User"]}>
            <MainLayout>
              <MyPayslips />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* my-payroll salary-structure */}
      <Route
        path="/my-payroll/salary-structure"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "User"]}>
            <MainLayout>
              <MySalaryStructure />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* my-payroll tax-documents */}
      <Route
        path="/my-payroll/tax-documents"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "User"]}>
            <MainLayout>
              <TaxDocuments />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* my-payroll certificates */}
      <Route
        path="/my-payroll/certificates"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "User"]}>
            <MainLayout>
              <Certificates />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* my-payroll certificates */}
      <Route
        path="/my-payroll/reimbursements"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "User"]}>
            <MainLayout>
              <Reimbursements />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Hiring Requests */}
      <Route
        path="/hiringrequests"
        element={
          <CampaignsProvider>
            <MastersProvider>
              <HiringRequestsProvider>
                <ProtectedRoute
                  allowedRoles={["Admin", "Manager", "HR", "User"]}
                >
                  <MainLayout>
                    <DesignationMasterProvider>
                      <HiringRequests />
                    </DesignationMasterProvider>
                  </MainLayout>
                </ProtectedRoute>
              </HiringRequestsProvider>
            </MastersProvider>
          </CampaignsProvider>
        }
      />

      {/* HOD Requests */}
      <Route
        path="/hod-requests"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "HOD"]}>
            <MainLayout>
              <HODRequests />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Hiring Requests */}
      <Route
        path="/recruitment-response"
        element={
          <CampaignsProvider>
            <MastersProvider>
              <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "User"]}>
                <MainLayout>
                  <RecruitmentResponses />
                </MainLayout>
              </ProtectedRoute>
            </MastersProvider>
          </CampaignsProvider>
        }
      />

      <Route
        path="/myrequests"
        element={
          <MyHiringRequestsProvider>
            <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "User"]}>
              <MainLayout>
                <MyRequests />
              </MainLayout>
            </ProtectedRoute>
          </MyHiringRequestsProvider>
        }
      />

      <Route
        path="/viewrequests"
        element={
          <HiringRequestsProvider>
            <ProtectedRoute allowedRoles={["HR", "Manager", "User"]}>
              <MainLayout>
                <ViewRequests />
              </MainLayout>
            </ProtectedRoute>
          </HiringRequestsProvider>
        }
      />

      {/* Campaigns */}
      <Route
        path="/campaigns"
        element={
          <MastersProvider>
            <CampaignsProvider>
              <CandidateProvider>
                <ProtectedRoute
                  allowedRoles={["Admin", "Manager", "HR", "User", "HOD"]}
                >
                  <MainLayout>
                    <Campaigns />
                  </MainLayout>
                </ProtectedRoute>
              </CandidateProvider>
            </CampaignsProvider>
          </MastersProvider>
        }
      />

      {/* Candidates */}
      <Route
        path="/candidates"
        element={
          <CampaignsProvider>
            <CandidateProvider>
              <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "HOD"]}>
                <MainLayout>
                  <Candidates />
                </MainLayout>
              </ProtectedRoute>
            </CandidateProvider>
          </CampaignsProvider>
        }
      />

      {/* Interviews */}
      <Route
        path="/interviews"
        element={
          <MastersProvider>
            <RecruitmentDashboardProvider>
              <InterviewsProvider>
                <ProtectedRoute
                  allowedRoles={["Admin", "Manager", "HR", "HOD"]}
                >
                  <MainLayout>
                    <Interviews />
                  </MainLayout>
                </ProtectedRoute>
              </InterviewsProvider>
            </RecruitmentDashboardProvider>
          </MastersProvider>
        }
      />

      <Route
        path="/scheduled-interviews"
        element={
          <CampaignsProvider>
            <CandidateProvider>
              <ScheduleInterviewsProvider>
                <ProtectedRoute
                  allowedRoles={["Admin", "Manager", "HR", "HOD"]}
                >
                  <MainLayout>
                    <ScheduledInterviews />
                  </MainLayout>
                </ProtectedRoute>
              </ScheduleInterviewsProvider>
            </CandidateProvider>
          </CampaignsProvider>
        }
      />

      <Route
        path="/my-scheduled-interviews"
        element={
          <CampaignsProvider>
            <CandidateProvider>
              <InterviewsProvider>
                <MyInterviewsProvider>
                  <ProtectedRoute
                    allowedRoles={["Admin", "Manager", "HR", "User", "HOD"]}
                  >
                    <MainLayout>
                      <MyScheduledInterviews />
                    </MainLayout>
                  </ProtectedRoute>
                </MyInterviewsProvider>
              </InterviewsProvider>
            </CandidateProvider>
          </CampaignsProvider>
        }
      />

      {/* Recruitment Dashboard */}
      <Route
        path="/recruitment-dashboard"
        element={
          <DepartmentMasterProvider>
            <RecruitmentDashboardProvider>
              <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "HOD"]}>
                <MainLayout>
                  <RecruitmentDashboard />
                </MainLayout>
              </ProtectedRoute>
            </RecruitmentDashboardProvider>
          </DepartmentMasterProvider>
        }
      />

      {/* Forms */}
      <Route
        path="/formlist"
        element={
          <FormsProvider>
            <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "HOD"]}>
              <MainLayout>
                <FormsList />
              </MainLayout>
            </ProtectedRoute>
          </FormsProvider>
        }
      />

      <Route
        path="/formbuilder"
        element={
          <FormsProvider>
            <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "HOD"]}>
              <FormsMasterProvider>
                <FormBuilder />
              </FormsMasterProvider>
            </ProtectedRoute>
          </FormsProvider>
        }
      />

      <Route
        path="/formbuilder/:id"
        element={
          <FormsProvider>
            <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "HOD"]}>
              <FormsMasterProvider>
                <FormBuilder />
              </FormsMasterProvider>
            </ProtectedRoute>
          </FormsProvider>
        }
      />

      {/* Form responses */}
      <Route
        path="/form_response"
        element={
          <ProtectedRoute allowedRoles={["Admin", "HR"]}>
            <MainLayout>
              <FormResponsePage />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Application Form responses */}
      <Route
        path="/application_form_response"
        element={
          <ProtectedRoute allowedRoles={["Admin", "HR"]}>
            <MainLayout>
              <ApplicationResponses />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* On-boarding Form responses */}
      <Route
        path="/on_boarding_form_response"
        element={
          <ProtectedRoute allowedRoles={["HR"]}>
            <MainLayout>
              <OnBoardingFormResponsePage />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Resignation */}
      <Route
        path="/resignation"
        element={
          <ResignationProvider>
            <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "HOD"]}>
              <MainLayout>
                <Resignation />
              </MainLayout>
            </ProtectedRoute>
          </ResignationProvider>
        }
      />

      {/* internal form route */}
      <Route
        path="/forms/:id"
        element={
          <ProtectedRoute
            allowedRoles={["HR", "Manager", "User", "Admin", "HOD"]}
          >
            <FormsProvider mode="internal">
              <FormRender />
            </FormsProvider>
          </ProtectedRoute>
        }
      />

      {/* Roles and Permissions */}
      <Route
        path="/roles"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <RoleProvider>
                <ManageRoles />
              </RoleProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/edit-role/:id"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <RoleProvider>
                <EditRole />
              </RoleProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/permissions"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PermissionProvider>
                <ManagePermissions />
              </PermissionProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/edit-permission/:id"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <EditPermission />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/assign-roles"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <UsersProvider>
                <RoleProvider>
                  <AssignRoles />
                </RoleProvider>
              </UsersProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/assign-permissions"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <UsersProvider>
                <PermissionProvider>
                  <RoleProvider>
                    <AssignPermissions />
                  </RoleProvider>
                </PermissionProvider>
              </UsersProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Users */}
      <Route
        path="/users"
        element={
          <UsersProvider>
            <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
              <MainLayout>
                <Users />
              </MainLayout>
            </ProtectedRoute>
          </UsersProvider>
        }
      />

      {/* Users */}
      <Route
        path="/upload-resumes"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <UploadResumes />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* offer letters */}
      <Route
        path="/offer-letters"
        element={
          <CampaignsProvider>
            <CandidateProvider>
              <OfferTemplatesProvider>
                <OfferLettersProvider>
                  <ProtectedRoute
                    allowedRoles={["Admin", "Manager", "HR", "User"]}
                  >
                    <MainLayout>
                      <OfferLettersPage />
                    </MainLayout>
                  </ProtectedRoute>
                </OfferLettersProvider>
              </OfferTemplatesProvider>
            </CandidateProvider>
          </CampaignsProvider>
        }
      />

      {/* doc generator */}
      <Route
        path="/doc-generator"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <DocumentGenerator />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* manage files */}
      <Route
        path="/manage-files"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <ManageFiles />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* offer templates */}
      <Route
        path="/offer-templates"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <OfferTemplatesProvider>
                <OfferTemplatesPage />
              </OfferTemplatesProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Attendance Management */}
      <Route
        path="/attendance_management/"
        element={
          <ProtectedRoute
            allowedRoles={["Manager", "HR", "User", "Admin", "HOD"]}
          >
            <MainLayout>
              <MultiOptions />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* time - Attendance, OT, Swipe-Request, ShortTimeOff, ShiftChange */}
      <Route
        path="/time"
        element={
          <ProtectedRoute
            allowedRoles={["Admin", "Manager", "User", "HR", "HOD"]}
          >
            <MainLayout>
              <Time />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* attendance dashboard */}
      <Route
        path="/attendance_management/dashboard"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "HOD"]}>
            <MainLayout>
              <AttendanceDashboard />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* attendance */}
      <Route
        path="/attendance_management/attendance"
        element={
          <ProtectedRoute
            allowedRoles={["Admin", "Manager", "User", "HR", "HOD"]}
          >
            <MainLayout>
              <AttendancePage />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* check employee attendance */}
      <Route
        path="/attendance_management/check-attendance"
        element={
          <ProtectedRoute
            allowedRoles={["Admin", "Manager", "User", "HR", "HOD"]}
          >
            <MainLayout>
              <CheckAttendancePage />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* attendance */}
      <Route
        path="/attendance_management/attendance-upload"
        element={
          <ProtectedRoute allowedRoles={["Admin", "HR"]}>
            <MainLayout>
              <AttendanceApiPage />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* swipe request */}
      <Route
        path="/attendance_management/swipe"
        element={
          <ProtectedRoute
            allowedRoles={["Admin", "Manager", "User", "HR", "HOD"]}
          >
            <MainLayout>
              <SwipeRequest />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* short time off */}
      <Route
        path="/attendance_management/short-time-off"
        element={
          <ProtectedRoute
            allowedRoles={["Admin", "Manager", "User", "HR", "HOD"]}
          >
            <MainLayout>
              <ShortTimeOff />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* shift change */}
      <Route
        path="/attendance_management/shift-change"
        element={
          <ProtectedRoute
            allowedRoles={["Admin", "Manager", "User", "HR", "HOD"]}
          >
            <MainLayout>
              <ShiftChange />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/attendance_management/mob-attendance"
        element={
          <ProtectedRoute
            allowedRoles={["Admin", "Manager", "User", "HR", "HOD"]}
          >
            <MainLayout>
              <MobileAttendance />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/attendance_management/mob-attendance/camera/:type"
        element={
          <ProtectedRoute
            allowedRoles={["Admin", "Manager", "User", "HR", "HOD"]}
          >
            <MainLayout>
              <CameraPage />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/attendance_management/my-approvers"
        element={
          <ProtectedRoute
            allowedRoles={["Admin", "Manager", "HR", "HOD", "User"]}
          >
            <MainLayout>
              <MyApprovers />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* leave - Co+, OD, leave */}
      <Route
        path="/leave"
        element={
          <ProtectedRoute
            allowedRoles={["Admin", "Manager", "User", "HR", "HOD"]}
          >
            <MainLayout>
              <Leave />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/attendance_management/leave_page"
        element={
          <ProtectedRoute
            allowedRoles={["Admin", "Manager", "User", "HR", "HOD"]}
          >
            <MainLayout>
              <LeavePage />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/attendance_management/co+"
        element={
          <ProtectedRoute
            allowedRoles={["Admin", "Manager", "User", "HR", "HOD"]}
          >
            <MainLayout>
              <COPlusPage />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/attendance_management/od"
        element={
          <ProtectedRoute
            allowedRoles={["Admin", "Manager", "User", "HR", "HOD"]}
          >
            <MainLayout>
              <OutdoorDutyPage />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/attendance_management/holidays"
        element={
          <ProtectedRoute
            allowedRoles={["Admin", "Manager", "User", "HR", "HOD"]}
          >
            <MainLayout>
              <HolidaysList />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/attendance_management/my-calender/"
        element={
          <ProtectedRoute
            allowedRoles={["Admin", "Manager", "User", "HR", "HOD"]}
          >
            <MainLayout>
              <HolidayMasterProvider>
                <PublicHolidayCalendar />
              </HolidayMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/attendance_management/leave-balance"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "User", "HR"]}>
            <MainLayout>
              <LeaveBalance />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/attendance_management/check-leave-balance"
        element={
          <ProtectedRoute
            allowedRoles={["Admin", "Manager", "User", "HR", "HOD"]}
          >
            <MainLayout>
              <CheckLeaveBalance />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/attendance_management/my-approvers/"
        element={
          <ProtectedRoute
            allowedRoles={["Admin", "Manager", "User", "HR", "HOD"]}
          >
            <MainLayout>
              <MyApprovers />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Approval Attendance */}
      <Route
        path="/attendance_management/pending-checkin"
        element={
          <ProtectedRoute allowedRoles={["Manager", "HR", "Admin"]}>
            <MainLayout>
              <CheckInApprovalPage />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/attendance_management/pending-checkout"
        element={
          <ProtectedRoute allowedRoles={["Manager", "HR", "Admin"]}>
            <MainLayout>
              <CheckOutApprovalPage />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Leave requests  */}
      <Route
        path="/attendance_management/leave-requests"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <LeaveApproverPage />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Masters - Department, EmploymentType, Workplace */}
      <Route
        path="/master/departments"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <DepartmentMasterProvider>
                <DepartmentMasters />
              </DepartmentMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/master/designations"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <DesignationMasterProvider>
                <DesignationMasters />
              </DesignationMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/master/employment-type"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <EmploymentTypeMasterProvider>
                <EmploymentTypeMasters />
              </EmploymentTypeMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/master/workplace"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <WorkplaceMasterProvider>
                <WorkplaceMasters />
              </WorkplaceMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/master/leave-type"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <LeaveTypeMasterProvider>
                <LeaveTypeMasters />
              </LeaveTypeMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/master/shifts"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <ShiftTimingMasterProvider>
                <ShiftMasters />
              </ShiftTimingMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/master/holidays"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <HolidayMasterProvider>
                <HolidayMasters />
              </HolidayMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/master/department-hods"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <DepartmentMasterProvider>
                <UsersProvider>
                  <DepartmentHODMasters />
                </UsersProvider>
              </DepartmentMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/master/leave-balance-master"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <UsersProvider>
                <LeaveBalanceProvider>
                  <LeaveBalanceMasters />
                </LeaveBalanceProvider>
              </UsersProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Forms Master */}
      <Route
        path="/master/forms-master"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "User"]}>
            <MainLayout>
              <FormsMasterProvider>
                <FormsMaster />
              </FormsMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Emergency Contacts */}
      <Route
        path="/emergency-contacts"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR", "User"]}>
            <MainLayout>
              <EmergencyContactsProvider>
                <EmergencyContacts />
              </EmergencyContactsProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Birthday Card Designer */}
      <Route
        path="/birthday-card-designer"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <CardDesigner />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* State Code Master */}
      <Route
        path="/master/state_code"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <StateCodeMasterProvider>
                <StateCodeMasters />
              </StateCodeMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Employee Grade Master */}
      <Route
        path="/master/employee-grades"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <EmployeeGradeMasterProvider>
                <EmployeeGradeMasters />
              </EmployeeGradeMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Category Master */}
      <Route
        path="/master/categories"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <CategoryMasterProvider>
                <CategoryMasters />
              </CategoryMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* State Code Master */}
      <Route
        path="/master/salary-grade"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <SalaryGradeMasterProvider>
                <SalaryGradeMasters />
              </SalaryGradeMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Approver module Master */}
      <Route
        path="/master/approver-modules"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <ApproverModuleMasterProvider>
                <ApproverModuleMaster />
              </ApproverModuleMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Employee Approver Master */}
      <Route
        path="/master/employee-approver"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <EmployeeApproverMasterProvider>
                <UsersProvider>
                  <ApproverModuleMasterProvider>
                    <ApprovalLevelMasterProvider>
                      <EmployeeApproverMaster />
                    </ApprovalLevelMasterProvider>
                  </ApproverModuleMasterProvider>
                </UsersProvider>
              </EmployeeApproverMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Approval Level Master */}
      <Route
        path="/master/approval-level"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <ApprovalLevelMasterProvider>
                <ApprovalLevelMaster />
              </ApprovalLevelMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Leave Policy Master */}
      <Route
        path="/master/leave-policy"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <LeavePolicyMasterProvider>
                <LeavePolicyMaster />
              </LeavePolicyMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Salary Component Master */}
      <Route
        path="/master/salary-component"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <ConfigurationComponentTypeMasterProvider>
                <SalaryComponentMaster />
              </ConfigurationComponentTypeMasterProvider>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Pay Structure Master */}
      <Route
        path="/master/pay-structure"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <PayStructureMaster />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Eligibility Rule Master */}
      <Route
        path="/master/eligibility-rule"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <EligibilityRuleMaster />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Employee Salary Assignment */}
      <Route
        path="/master/employee-salary-assignment"
        element={
          <ProtectedRoute allowedRoles={["Admin", "Manager", "HR"]}>
            <MainLayout>
              <EmployeeSalaryAssignment />
            </MainLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
